export default {"src":"/_next/static/media/Apache Kafka.ea87895a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};